module.exports = __webpack_public_path__ + "static/img/service (5).5b559345.jpg";